import script from "./BlogIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogIndex.vue?vue&type=script&setup=true&lang=js"

import "./BlogIndex.vue?vue&type=style&index=0&id=b99b1334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b99b1334"]])

export default __exports__